import React from 'react';
import { StepViewModel } from '../../models/step';
import { InputType } from '../../enums/input-type.enum';
import { ColorPickerViewRender } from '../../views/ColorPickerViewRender';
import { BraSizePickerViewRender } from '../../views/BraSizePickerViewRender';
import { FinalSizeViewRender } from '../../views/FinalSizeViewRender';
import { camiBodysuitBraSize } from '../../utils/bra-helper';

export const CamiBodysuitSteps: StepViewModel[] = [
  {
    key: 'bra',
    text: 'What is your bra size?',
    progress: 0,
    options: [
      {
        text: '',
        nextStepKey: 'waist-instructions',
      },
      {
        text: '',
        nextStepKey: 'not-ready',
      },
    ],
    render: (props, onChange) => {
      return (
        <BraSizePickerViewRender
          {...props}
          onChange={onChange}
          key={'bra'}
          nextStepKey={'waist-instructions'}
          braSizeLookupFn={camiBodysuitBraSize}
          unsupportedStepKey={'not-ready'}
        />
      );
    },
  },
  {
    key: 'waist-instructions',
    text: 'Please measure your waist as shown below:',
    subText:
      'Waist measurements should be taken at the natural waist, the smallest point of the torso. It is usually a few inches below your bust, and a couple inches above your belly button.',
    image: 'measure-waist.svg',
    options: [
      {
        text: 'CONTINUE',
        inputType: InputType.CTAButton,
        nextStepKey: 'waist-measurement',
      },
    ],
  },
  {
    key: 'waist-measurement',
    text: 'What is your waist measurement?',
    options: [
      {
        imperialText: '23" or lower',
        metricText: '58 cm or lower',
        nextStepKey: 'height',
      },
      {
        imperialText: '24"',
        metricText: '61 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '25"',
        metricText: '64 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '26"',
        metricText: '66 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '27"',
        metricText: '69 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '28"',
        metricText: '71 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '29"',
        metricText: '74 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '30"',
        metricText: '76 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '31"',
        metricText: '79 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '32"',
        metricText: '81 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '33"',
        metricText: '84 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '34"',
        metricText: '86 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '35"',
        metricText: '89 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '36"',
        metricText: '91 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '37"',
        metricText: '94 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '38"',
        metricText: '97 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '39"',
        metricText: '99 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '40"',
        metricText: '102 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '41"',
        metricText: '104 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '42"',
        metricText: '107 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '43"',
        metricText: '109 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '44"',
        metricText: '112 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '45"',
        metricText: '114 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '46"',
        metricText: '117 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '47"',
        metricText: '119 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '48"',
        metricText: '122 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '49"',
        metricText: '124 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '50"',
        metricText: '127 cm',
        nextStepKey: 'height',
      },
      {
        imperialText: '51"',
        metricText: '130 cm',
        nextStepKey: 'not-ready',
      },
      {
        imperialText: '52"',
        metricText: '132 cm',
        nextStepKey: 'not-ready',
      },
      {
        imperialText: '53" or above',
        metricText: '135 cm',
        nextStepKey: 'not-ready',
      },
    ],
  },
  {
    key: 'height',
    text: 'How tall are you?',
    progress: 90,
    options: [
      {
        imperialText: '5\'0" or below',
        metricText: '150 cm or below',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'1"',
        metricText: '155 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'2"',
        metricText: '157 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'3"',
        metricText: '160 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'4"',
        metricText: '163 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'5"',
        metricText: '165 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'6"',
        metricText: '168 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'7"',
        metricText: '170 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'8"',
        metricText: '173 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'9"',
        metricText: '175 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'10"',
        metricText: '178 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '5\'11"',
        metricText: '180 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '6\'0"',
        metricText: '183 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '6\'1"',
        metricText: '185 cm',
        nextStepKey: 'results',
      },
      {
        imperialText: '6\'2"',
        metricText: '188 cm or above',
        nextStepKey: 'results',
      },
    ],
  },
  {
    key: 'results',
    text: '[engine]',
    subText: 'Do you agree with our recommendation?',
    progress: 95,
    options: [
      {
        text: '',
        nextStepKey: 'pick-a-color',
      },
    ],
    render: (props, onChange) => {
      return <FinalSizeViewRender {...props} nextStepKey="pick-a-color" onChange={onChange} />;
    },
  },
  {
    key: 'not-ready',
    text: `Hey love,

Our design team is still working on the bra size {bra}, and it's not available yet.

If you'd like to be notified as soon as our expanded sizes launch, please leave your email below.

Alternatively, you can order the tank in size 4X - if that's not the right size, we have an excellent return policy :)`,
    progress: 99,
    options: [
      {
        inputType: InputType.Email,
        nextStepKey: 'results',
        klaviyoKey: 'klaviyo4x5xId',
      },
      {
        inputType: InputType.SecondaryCTAButton,
        nextStepKey: 'pick-a-color',
        text: 'ORDER IN SIZE 4X',
      },
    ],
  },
  {
    key: 'pick-a-color',
    text: 'pick-a-color',
    progress: 100,
    options: [],
    render: (props, onChange) => {
      return <ColorPickerViewRender {...props} onChange={onChange} />;
    },
  },
];
